import Bowser from 'bowser';
import { getRecaptcha } from './form';

$('.ocr-file').on('change', async function () {
    $('input[name="uuid"]').remove();
    $('.file-error').remove();

    const file = this.files[0]
    if (!file) {
        return;
    }

    const billType = $('[name="billTypeCheckboxParagon"]:checked').val();
    $('form').append(`<input type="hidden" name="personal_data[billType]" value="${billType}">`);

    $('.landing').addClass('d-none');
    $('.application').addClass('d-none');
    $('#upload-file-modal').modal('hide');
    $('.loading').addClass('show');
    $('.s-hero__loading').addClass('show');

    $('html, body').animate({
        scrollTop: 0
    }, 300);

    if (billType === 'Paragon') {
        try {
            let formData = new FormData()
            formData.set('file', file)
            // formData.set('g-recaptcha-response', await getRecaptcha())
            formData.set('_token', $(this).data('token'))
            formData.set('wsUuid', await getWebsocketUuid());
            openWebSocket(formData.get('wsUuid'));

            var data = await $.ajax({
                type: 'POST',
                url: $(this).data('url'),
                data: formData,
                processData: false,
                contentType: false,
            });
        } catch (xhr) {
            let message = Object.values(xhr.responseJSON?.errors ?? []).flat().join('<br>') || 'Wystąpił nieznany błąd, proszę spróbować jeszcze raz.';
            $(this).closest('.form-group').append(`<div class="invalid-feedback d-block file-error">${message}</div>`)
            $('.loading').removeClass('show');
            $('.s-hero__loading').removeClass('show');
            $('.landing').removeClass('d-none');
            $('#upload-file-modal').modal('show');
            return;
        }
        $('#file-name').val(file.name)
        $('form.application-form').find('[name=receiptUuid]').remove();
        $('form.application-form').append(`<input type="hidden" name="receiptUuid" value="${data.receiptUuid}">`);


        for (let name in data.billData) {
            $(`input[name="personal_data[${name}]"]`).val(data.billData[name]).trigger('input');
        }
    } else {
        $('input[name="personal_data[billPos]"]').prop('disabled', true);
    }

    const reader = new FileReader();
    reader.onload = (event) => {
        $('.s-hero__bill-image img').prop("src", event.target.result);
        if (!file.type.includes("image")) {
            $('.s-hero__bill-image img').prop("src", $('.s-hero__bill-image img').data("src"));
        }
    };
    reader.readAsDataURL(file);

    $('#file-name').val(file.name);

    let container = new DataTransfer();
    container.items.add(file);
    document.querySelector('#personal_data_files_paragon').files = container.files;
    $('#personal_data_files_paragon').trigger('change');

    $('.loading').removeClass('show');
    $('.s-hero__loading').removeClass('show');
    $('.application').removeClass('d-none');
    $('.application').addClass('show');

    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': 'form_view',
            'page_path': '/',
            'page_title': 'Formularz zgłoszeniowy',
            'form_name': 'Kozel Loteria 2025',
        });
    }
});

function getWebsocketUuid() {
    return fetch(WEBSOCKET_UUID_URL)
        .then(response => response.json())
        .then(data => data.uuid);
}

function openWebSocket(uuid) {
    var ws = new WebSocket(OCR_URL.replace(/^https?:\/\//, 'wss://') + 'ws');
    ws.onmessage = data => { 
        // $('#ocrAwaitingDataView').html($('#ocrAwaitingDataView').html() + data.data.replace('\n', '<br />'));
        // $('#ocrAwaitingDataView').scrollTop($('#ocrAwaitingDataView')[0].scrollHeight);
    };
    ws.onopen = () => ws.send(JSON.stringify({ uuid: uuid }));
}

$('[name="billTypeCheckboxParagon"]').on('change', function () {
    if (window.innerWidth < 992) {
        if ($('[name="billTypeCheckboxParagon"]:checked').val() === 'Faktura') {
            $('.scanner-container').find('iframe').remove();
            $('.scanner-container').addClass('d-none');
            $('label[for="file_paragon"]').removeClass('d-none');
        } else {
            $('label[for="file_paragon"]').addClass('d-none');
            $('.scanner-container').removeClass('d-none');
            const scannerUrl = $('.scanner-container').attr('data-url');
            $('.scanner-container').append(
                `<iframe width="100%" height="auto" id="scanner" style="width: 100%; height: 100%; min-height: 80dvh;" src="${scannerUrl}" allow="camera ${scannerUrl}; microphone ${scannerUrl}/"></iframe>`
            );
        }
    }
});

// $('.ocr-file').on('click', function (e) {
//     if (['mobile', 'tablet'].includes(Bowser.parse(navigator.userAgent).platform.type)) {
//         e.preventDefault();
//
//         $('#scanner').modal('show');
//     }
// });

// $('#scanner').on('show.bs.modal', function () {
//     const scannerUrl = $(this).find('.scanner-container').attr('data-url');
//
//     $(this).find('.scanner-container').append(
//         `<iframe width="100%" height="auto" id="scanner" style="width: 100%; height: 100%; min-height: 90dvh;" src="${scannerUrl}" allow="camera ${scannerUrl}; microphone ${scannerUrl}/"></iframe>`
//     );
// });
//
// $('#scanner').on('hide.bs.modal', function () {
//     if (window.innerWidth < 992) {
//         $(this).find('.scanner-container iframe').remove();
//     }
// });

window.addEventListener('message', function(event) {
    let scannerData;

    try {
        scannerData = JSON.parse(event.data);
    } catch (e) {
        scannerData = null;
    }

    if (scannerData && scannerData?.name === 'scannerImage') {
        let file = dataURLtoFile(scannerData.data, 'ocr.png');
        let container = new DataTransfer();
        container.items.add(file);
        $('.ocr-file').prop('files', container.files).trigger('change');
        $('#scanner').modal('hide');
    }
});

function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}

$('#upload-file-modal').on('shown.bs.modal', function () {
    // if (window.innerWidth < 992) {
        if ($('[name="billTypeCheckboxParagon"]').length > 0) {
            $('#personal_data_billTypeCheckboxParagon').trigger('change');
            $('#personal_data_billTypeCheckboxParagon').prop('checked', true);
        }
    // }
});
